module.exports = __webpack_public_path__ + "files/54839e604f1e1d0c1f3a57638b04e225.png";